import { useAppSelector } from '@/hooks';
import { selectLookup } from '@/store/slices';
import type { ExternalLookupOptions } from '@/typings';

import { useFormValues } from '../core';
// Imported by path, not through the utils barrel, to keep hooks and utils acyclic.
import { findActiveFieldWarning } from '../utils/findActiveFieldWarning';
import type { FormFieldWarning, FormInitialValues, SingleFormField } from '../typings';

/** The external lookup options the select adapter stored for the field; undefined for any other field. */
export const useExternalLookupOptions = (
  fieldId: string,
): ExternalLookupOptions | undefined =>
  useAppSelector(state => selectLookup(state).externalLookups[fieldId]?.options);

/**
 * The field's active warning, or undefined. Re-derives on every value change,
 * and is deliberately not gated on `touched` so a saved or pre-filled date
 * warns on mount.
 */
export const useFieldWarning = (
  field: SingleFormField,
): FormFieldWarning | undefined => {
  const values = useFormValues<FormInitialValues>();
  const lookupOptions = useExternalLookupOptions(field.fieldId);

  return findActiveFieldWarning(field, values[field.fieldId], lookupOptions);
};
